import { UI } from '@genial/components';
import { BoxBorder } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box } from 'native-base';

export const EquityContent = () => {
  return (
    <Box
      w="full"
      bg={Utils.Responsive.PhoneTablet({ tablet: 'neutral.white', phone: undefined })}
      borderRadius={BoxBorder.heavy}
      p={Utils.Responsive.All({ desktop: 'inset.md', tablet: 'inset.sm', phone: 0 })}>
      <UI.Shadow level={1} overflow="hidden">
        <iframe
          id="tradingview_a1e1b"
          src="https://s.tradingview.com/bovespa/widgetembed/?symbol=IBOV&amp;interval=1&amp;hidesidetoolbar=1&amp;symboledit=1&amp;saveimage=1&amp;toolbarbg=f1f3f6&amp;editablewatchlist=1&amp;details=1&amp;studies=&amp;widgetbarwidth=300&amp;hideideas=1&amp;theme=White&amp;style=2&amp;timezone=exchange&amp;withdateranges=1&amp;studies_overrides=%7B%7D&amp;overrides=%7B%7D&amp;enabled_features=%5B%5D&amp;disabled_features=%5B%5D&amp;locale=pt&amp;"
          width="100%"
          height="560px"
          frameBorder="0"
          style={{ border: 'none', margin: 0, padding: 0 }}
          allowTransparency
          allowFullScreen
        />
      </UI.Shadow>
    </Box>
  );
};
